import { StateCreator } from "zustand";
import type { SkyViewStore } from "./index";

export type SearchMode = "exact" | "context";

export interface SearchHighlightSlice {
  searchQuery: string | null;
  highlightedPageId: string | null;
  highlightedSectionId: string | null;
  searchMode: SearchMode;
  setSearchQuery: (query: string | null) => void;
  setHighlightedPageId: (pageId: string | null) => void;
  highlightReference: (
    pageId: string,
    sectionId: string,
    context: string
  ) => void;
  clearSearchHighlight: () => void;
}

export const createSearchHighlightSlice: StateCreator<
  SkyViewStore,
  [["zustand/persist", unknown], ["zustand/immer", never]],
  [],
  SearchHighlightSlice
> = (set) => ({
  searchQuery: null,
  highlightedPageId: null,
  highlightedSectionId: null,
  searchMode: "exact",
  setSearchQuery: (query: string | null) =>
    set(() => ({
      searchQuery: query,
      searchMode: "exact",
    })),
  setHighlightedPageId: (pageId: string | null) =>
    set(() => ({
      highlightedPageId: pageId,
    })),
  highlightReference: (pageId: string, sectionId: string, context: string) =>
    set(() => ({
      searchQuery: context,
      highlightedPageId: pageId,
      highlightedSectionId: sectionId,
      searchMode: "context",
    })),
  clearSearchHighlight: () =>
    set(() => ({
      searchQuery: null,
      highlightedPageId: null,
      highlightedSectionId: null,
      searchMode: "exact",
    })),
});
